import React from 'react';
import styled, { css } from 'styled-components';
import { media } from 'components/styles';

// Import utilities
import {
	useNextProgramParentalControl,
	useSystemSupport
} from 'components/utilities';

// Import components
import {
	Loader,
	Button,
	PlayerError,
	PlayerElements as Player,
	PlayerPip,
	SupportError
} from 'components/elements';
import PlayerControllers from '../player_overlay/player_controllers/PlayerControllers';
import { PlayerStickyButtons } from 'components/elements/organisms/player/PlayerStickyButtons';
import PlayerDestroy from '../player_context/PlayerDestroy';

// Import context
import { usePlayerTvContext } from 'components/context/player/player_tv';

// Import helpers
import { PLAYER_SELECTORS } from 'helpers/variables';

const PlayerTvContent = ({ error, setPlayerCustomError, type }) => {
	const {
		isReady,
		isPaused,
		play,
		pause,
		destroy,
		setFullScreen: playerFullScreen,
		isEnded,
		repeat,
		showLoader,
		isSidebarVisible,
		isFocus,
		isLive,
		isFullScreen
	} = usePlayerTvContext();

	const { playerType } = useNextProgramParentalControl();

	const {
		showSupportMessage,
		supportError,
		setSupportAccept
	} = useSystemSupport();

	const closeButtonCondition = !isSidebarVisible && isFullScreen && isFocus;

	const handleBigPlayButtonClick = () => {
		if (isEnded) return repeat();
		return isPaused ? play() : pause();
	};

	const isPlayerDetails = type === PLAYER_SELECTORS.DETAILS;

	return (
		<>
			<PlayerDestroy
				errorAction={setPlayerCustomError}
				destroyPlayer={destroy}
				error={error}
				isLive={isLive}
			/>

			{showLoader && (
				<Loader zIndex={1} position="absolute" background={false} />
			)}

			{closeButtonCondition && (
				<ButtonCloseFullScreen
					onClick={playerFullScreen}
					modifiers={['icon', 'playerIconHover']}
				>
					<Player.IconCloseThin />
				</ButtonCloseFullScreen>
			)}

			{isReady && (
				<>
					<PlayerStickyButtons isSticky={!isPlayerDetails && !isFullScreen}>
						<PlayerControllers isFocus={isFocus} type={type} />
					</PlayerStickyButtons>

					{isPaused && (
						<Button
							isCatchupControllers={false}
							modifiers={['icon', 'catchup', 'playerIconHover', 'playerPlay']}
							onClick={handleBigPlayButtonClick}
						>
							<IconPlayStyled />
						</Button>
					)}
				</>
			)}

			<PlayerPip isReady={isReady} />

			{error.isError && <PlayerError error={error} playerType={playerType} />}

			{showSupportMessage && (
				<SupportError
					error={supportError}
					setSupportAccept={setSupportAccept}
					playerType={type}
				/>
			)}
		</>
	);
};

const ButtonCloseFullScreen = styled(Button)`
	position: absolute;
	top: 5rem;
	right: 4rem;
	z-index: 10;
`;

const IconPlayStyled = styled(Player.IconPlay)`
	width: 5rem;
	height: 5rem;

	${media.min.xmin(css`
		width: 10rem;
		height: 10rem;
	`)}

	${media.min.min(css`
		width: 15rem;
		height: 15rem;
	`)}
`;

export default PlayerTvContent;
